import React from 'react'

const UserTrading = () => {
  return (
    <div>UserTrading</div>
  )
}

export default UserTrading